"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _callBoth = require("../_utils/callBoth");
var _Icon = _interopRequireDefault(require("../Icon"));
var _uuid = require("../_utils/uuid");
var _MenuContext = require("./MenuContext");
var _noop = require("../_utils/noop");
var _mergeRefs = require("../_utils/mergeRefs");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["title", "icon", "tag", "selected", "external", "className", "onClick", "render"]; // import scrollIntoView from "scroll-into-view-if-needed";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var defaultRender = function defaultRender(children) {
  return /*#__PURE__*/_react.default.createElement("a", null, children);
};
var MenuItem = exports.MenuItem = /*#__PURE__*/(0, _react.forwardRef)(function MenuItem(_ref, fRef) {
  var title = _ref.title,
    icon = _ref.icon,
    tag = _ref.tag,
    selected = _ref.selected,
    external = _ref.external,
    className = _ref.className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _noop.noop : _ref$onClick,
    _ref$render = _ref.render,
    render = _ref$render === void 0 ? defaultRender : _ref$render,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var classPrefix = (0, _usePrefixCls.usePrefixCls)('menu');
  var _useContext = (0, _react.useContext)(_MenuContext.MenuContext),
    setMobileCollapsed = _useContext.setMobileCollapsed;
  var _useContext2 = (0, _react.useContext)(_MenuContext.SubMenuContext),
    inSubMenu = _useContext2.inSubMenu,
    onSelectedChange = _useContext2.onSelectedChange,
    onTagChange = _useContext2.onTagChange;
  var idRef = (0, _react.useRef)((0, _uuid.uuid)());

  // useEffect(() => {
  //   if (ref.current && selected) {
  //     scrollIntoView(ref.current, {
  //       scrollMode: "if-needed",
  //       block: "nearest",
  //       inline: "nearest",
  //     });
  //   }
  // }, [ref, selected]);

  (0, _react.useEffect)(function () {
    onTagChange(idRef.current, !!tag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);
  (0, _react.useEffect)(function () {
    return function () {
      onTagChange(idRef.current, false);
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  (0, _react.useEffect)(function () {
    selected && onSelectedChange(idRef.current, selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);
  var _ref2 = Array.isArray(icon) ? icon : [icon, icon],
    _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
    defaultIcon = _ref3[0],
    activeIcon = _ref3[1];
  var children = render( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, defaultIcon && !inSubMenu && (typeof defaultIcon === "string" ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(classPrefix, "-menu__list-icon"),
    src: defaultIcon,
    alt: "icon"
  }) : defaultIcon), activeIcon && !inSubMenu && (typeof activeIcon === "string" ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(classPrefix, "-menu__list-icon is-selected"),
    src: activeIcon,
    alt: "icon"
  }) : activeIcon), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__text")
  }, title, external && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "externallink"
  }))));
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
    ref: (0, _mergeRefs.mergeRefs)(fRef, ref),
    className: (0, _classnames.default)(className, {
      "is-selected": selected
    }),
    onClick: function onClick() {
      return setMobileCollapsed(false);
    }
  }, props), /*#__PURE__*/_react.default.cloneElement(children, {
    className: (0, _classnames.default)("".concat(classPrefix, "-menu__item"), children.props.className),
    onClick: (0, _callBoth.callBoth)(onClick, children.props.onClick)
  }));
});
MenuItem.displayName = "MenuItem";